module.exports = __webpack_public_path__ + "img/basic.09465162.png";